import { FormEvent } from 'react';
import { Button, ButtonGroup, ButtonToolbar, Col, FormControl, Row, ToggleButton, ToggleButtonGroup, Well } from 'react-bootstrap';
import { ICenterBase, ICenterFiveStarSurveyType } from '@nkr/models/index';

interface IProps {
    startDate: string,
    endDate: string,
    surveyType: ICenterFiveStarSurveyType,
    isAdmin: boolean,
    section: number,
    centerList: ICenterBase[],
    onFilterChange: (startDate: string, endDate: string, surveyType: ICenterFiveStarSurveyType) => void,
    onSectionChange: (section: number)=>void,
    onFilter: () => void
}

const CenterFiveStarSurveyFilter = (props: IProps) => {
    const handleStartDateChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        let startDate = e.currentTarget.value;

        props.onFilterChange(startDate, props.endDate, props.surveyType);
    };

    const handleEndDateChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        let endDate = e.currentTarget.value;

        props.onFilterChange(props.startDate, endDate, props.surveyType);
    };

    const handleStatusChange = (e: FormEvent<HTMLInputElement>) => {
        let surveyType = props.surveyType;

        surveyType[e.currentTarget.value.toLowerCase()] = !props.surveyType[e.currentTarget.value.toLowerCase()];

        props.onFilterChange(props.startDate, props.endDate, surveyType);
    };

    return (
        <Well>
            <Row>
                <Col xs={12} lg={3}>
                    <div>&nbsp;</div>
                    <ButtonGroup>
                        <input type='button' className={"btn " + (props.surveyType.dash ? 'btn-primary active' : 'btn-default')} name='statuses' value='DASH' onClick={handleStatusChange} />
                        <input type='button' className={"btn " + (props.surveyType.dcn ? 'btn-primary active' : 'btn-default')} name='statuses' value='DCN' onClick={handleStatusChange} />
                        <input type='button' className={"btn " + (props.surveyType.nkr ? 'btn-primary active' : 'btn-default')} name='statuses' value='NKR' onClick={handleStatusChange} />
                    </ButtonGroup>
                </Col>
                <Col xs={12} lg={3}>
                    <div style={{ marginRight: 5 }}>Start Date:&nbsp;</div>
                    <FormControl
                        type='date'
                        name='startDate'
                        value={props.startDate}
                        onChange={handleStartDateChange}
                    />
                </Col>
                <Col xs={12} lg={3}>
                    <div style={{ marginRight: 5 }}>End Date:</div>
                    <FormControl
                        type='date'
                        name='endDate'
                        value={props.endDate}
                        onChange={handleEndDateChange}
                    />
                </Col>

                <Col xs={12} lg={3}>
                    <div>&nbsp;</div>
                    <Button bsStyle='primary' style={{ width: '100%' }} onClick={props.onFilter}>Filter</Button>
                </Col>
            </Row>

            <br />

            <Row>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginLeft: '20px' }} >
                    <div style={{ marginRight: 5 }}>Sections:</div>
                    <ButtonToolbar>
                        <ToggleButtonGroup type="radio" name="options" defaultValue={props.section}>
                            <ToggleButton className="btn-bg" onClick={() => props.onSectionChange(0)} value={0}>
                                All
                            </ToggleButton>
                            <ToggleButton className="btn-bg" onClick={() => props.onSectionChange(1)} value={1}>
                                Workup
                            </ToggleButton>
                            <ToggleButton className="btn-bg" onClick={() => props.onSectionChange(2)} value={2}>
                                Pre-Op
                            </ToggleButton>
                            <ToggleButton className="btn-bg" onClick={() => props.onSectionChange(3)} value={3}>
                                Surgery +3
                            </ToggleButton>
                            <ToggleButton className="btn-bg" onClick={() => props.onSectionChange(4)} value={4}>
                                Surgery +30
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </ButtonToolbar>
                </div>
            </Row>
        </Well>
    );
}

export default CenterFiveStarSurveyFilter;

